import React, { useState } from 'react';
import './BuscarDni.css';
import { MdSentimentVeryDissatisfied } from 'react-icons/md';
import { descargarCarnet } from '../util/descargarCarnet';



export default function BuscarDni() {
  const [dni, setDni] = useState('');
  const [resultado, setResultado] = useState(null);
  const [error, setError] = useState('');
  const [descargando, setDescargando] = useState(false);

  // Baja la tarjeta mostrada como imagen (util/descargarCarnet; la foto, el fondo y el QR
  // se leen con CORS: R2 y la API lo permiten).
  const descargar = async () => {
    setDescargando(true);
    await descargarCarnet('tarjeta-carnet', resultado.slug || resultado.dni || 'carnet');
    setDescargando(false);
  };

  const BuscarBtn = async () => {
    setError('');
    setResultado(null);

    try {
      // Va directo al dominio de pegasus (tenant 'kalel', ya registrado en
      // django-tenants y con su propio nginx site/SSL) en vez de a
      // api.kalelsac.com -- ese dominio depende del backend viejo de kalel
      // (ya apagado) solo para hacer de puente hacia pegasus en esta ruta.
      const response = await fetch('https://kalel-backend.ingees.com.pe/api/consultas/consultatarjeta', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ dni }),
      });

      const data = await response.json();
      if (Array.isArray(data) && data.length > 0) {
        setResultado(data[0]);
      } else {
        setError('No se han encontrado resultados');
      }
    } catch (error) {
      setError('Error al consultar la API');
      console.error(error);
    }
  }

  const restarUnAnio = (fechaString) => {
    const partes = fechaString.split('/'); // ["11", "04", "2023"]
    const anio = parseInt(partes[2], 10);  // 2023
    return anio - 1;
  };


  return (
    <div className="buscar-page">
      <div className="banner">
        <img
          src="https://kalelsac.com/img/mediobanner.png"
          alt="Banner principal"
          className="banner-img"
        />
      </div>
      <div className="buscar-header">
        <input
          type="text"
          value={dni}
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d{0,13}$/.test(value)) {
              setDni(value);
            }
          }}
          placeholder="Ingrese su DNI"
        />
        <button onClick={BuscarBtn}>Buscar</button>
        {error && (
          <div className="error-message">
            <MdSentimentVeryDissatisfied className="icono-error" />
            <p>{error}</p>
          </div>
        )}
      </div>

      {resultado && (
        <>
        <div className="tarjeta-wrapper">
          <div
            id="tarjeta-carnet"
            className="tarjeta-fondo"
            style={{ backgroundImage: `url(${resultado.fondo})` }}
          >
            <div className="tarjeta-content">
              <div className="foto-container">
                {resultado.foto ? (
                  <img
                    src={resultado.foto}
                    alt="Foto del conductor"
                    onError={(e) => (e.target.style.display = 'none')}
                  />
                ) : (
                  <div className="sin-foto">Sin foto</div>
                )}
                <p>
                  <strong style={{ color: resultado.state ? 'green' : 'orange', fontWeight: 'bold' }}>
                    {resultado.state ? 'ACTIVO' : 'DESACTIVADO'}
                  </strong>
                </p>
              </div>

              <p>
                NOMBRE:<br />
                <strong>{`${resultado.nombres} ${resultado.apellidos}`.toUpperCase()}</strong>
              </p>
              <p>
                DNI:<br />
                <strong>{resultado.dni}</strong>
              </p>
              <p>
                PERSONA JURIDICA:<br />
                <strong>{resultado.empresa}</strong>
              </p>
              <p >
                DISTRITO:<br />
                <strong>{resultado.distrito}</strong>
              </p>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <p>
                    VIGENTE HASTA: <strong>{resultado.fecha_fin}</strong>
                  </p>
                  <p>
                    CODIGO: <strong>{resultado.codigo} - {restarUnAnio(resultado.fecha_fin)}</strong>
                  </p>
                </div>
                <img src={resultado.qr} alt="Código QR" style={{ width: '80px', height: '80px', marginLeft: '10px' }} />
              </div>

            </div>
          </div>
        </div>
        <div className="descargar-wrapper">
          <button className="btn-descargar" onClick={descargar} disabled={descargando}>
            {descargando ? 'GENERANDO...' : 'DESCARGAR CARNET'}
          </button>
        </div>
        </>
      )}
    </div>
  );
}